













































































import { BButton, BFormGroup, BFormInput, BFormSelect } from "bootstrap-vue";
import { computed, defineComponent, PropType, ref } from "@vue/composition-api";
import { ButtonType, TemplateComponentUrlButtonsInterface } from "@/interfaces/template.interface";
import DescriptionInputCounter from "@/views/modules/settings/whatsapp-templates/components/descriptionInputCounter.vue";
import useMessageTemplates from "@/composables/useMessageTemplates";
import EmojiPicker from "@/components/emojiPicker.vue";
import { ValidationProvider } from "vee-validate";

export default defineComponent({
    components: {
        ValidationProvider,
        EmojiPicker,
        DescriptionInputCounter,
        BFormGroup,
        BFormSelect,
        BButton,
        BFormInput,
    },
    props: {
        value: {
            required: true,
            type: Object as PropType<TemplateComponentUrlButtonsInterface>,
        },
        changeableType: {
            type: Boolean,
            required: true,
        },
    },
    setup(props, { emit }) {
        const { callToActionButtonTypes } = useMessageTemplates();

        const urlButton = computed<TemplateComponentUrlButtonsInterface>({
            get: () => props.value,
            set: (value) => {
                emit("input", value);
            },
        });

        const callToActionTypeSelected = ref(ButtonType.URL);

        return { urlButton, callToActionButtonTypes, callToActionTypeSelected };
    },
});
